import { UrlConstants } from "../url.constants";
export class ApiOrganisationConstants {
    static URL = UrlConstants.API_V2 + "Organisation";
    static FUNCTION_REJECT_APPLICATION = "RejectApplication";
    static FUNCTION_ACCEPT_APPLICATION = "AcceptApplication";
    static FUNCTION_GET_APPLICATIONS = "GetApplications";
    static FUNCTION_REINSTATE_ORGANISATION = "ReinstateOrganisation";
    static FUNCTION_SUSPEND_ORGANISATION = "SuspendOrganisation";
    static FUNCTION_UNSUSPEND_USER_FROM_ORGANISATION = "UnsuspendUserFromOrganisation";
    static FUNCTION_SUSPEND_USER_FROM_ORGANISATION = "SuspendUserFromOrganisation";
    static FUNCTION_REMOVE_USERS_FROM_ORGANISATION = "RemoveUsersFromOrganisation";
    static FUNCTION_REMOVE_USER_FROM_ORGANISATION = "RemoveUsersFromOrganisation";
    static FUNCTION_GET_USERS = "GetUsers";
    static FUNCTION_APPLY_TO_ORGANISATION = "ApplyToOrganisation";
    static FUNCTION_UPLOAD_LOGO = "UploadLogo";
    static FUNCTION_DOWNLOAD_LOGO = "DownloadLogo";
    static FUNCTION_DELETE_LOGO = "DeleteLogo";
    static FUNCTION_BACKUP_SETTINGS = "BackupSettings";
    static FUNCTION_RESTORE_SETTINGS = "RestoreSettings";
}
